import { APIDataDocumentSchemaRevision, APIMetaDataDocumentSchemaRevisionPropertyNames } from '@evertel/types'
import { Store } from '@evertel/types'
import { decorate, injectable } from '@evertel/di'

class DocumentSchemaRevisionStore extends Store<APIDataDocumentSchemaRevision> {
    constructor() {
        super([...APIMetaDataDocumentSchemaRevisionPropertyNames, 'media'])
    }
}

decorate(injectable(), DocumentSchemaRevisionStore)

export { DocumentSchemaRevisionStore }
